import * as XLSX from 'xlsx';
import { getTransactionGrossAmount, getTransactionGrossCurrency, MerchantTransactionAmountLike } from './merchantAmounts';
import { paymentChannelName } from './paymentChannels';

export interface MerchantExportPayment extends MerchantTransactionAmountLike {
    merchantOrderId?: string | null;
    payment_id: string;
    user_id?: string;
    merchantPaymentId?: string;
    merchantWithdrawalId?: string;
    status: string;
    requisite_type?: string | null;
    traffic_type?: string | null;
    requested_payment_method?: string | null;
    created_at: string;
    completed_at?: string | null;
}

const numeric = (value: number | null | undefined): number | string =>
    typeof value === 'number' && Number.isFinite(value) ? value : '-';
const identifier = (value?: string): string => value == null || value === '' ? '-' : String(value);
const statuses: Record<string, string> = {
    assigned: 'Assigned', receipt_uploaded: 'Receipt Uploaded', confirmed: 'Confirmed',
    completed: 'Completed', cancelled: 'Cancelled',
};

export const merchantPaymentExportRow = (payment: MerchantExportPayment) => {
    const completed = payment.status === 'completed';
    return {
        'System Payment ID': identifier(payment.payment_id),
        'Merchant Order ID': identifier(payment.merchantOrderId || (payment.order_type === 'withdraw' ? payment.merchantWithdrawalId : payment.merchantPaymentId)),
        'Client ID': identifier(payment.user_id),
        'Method': payment.order_type === 'deposit' ? 'Deposit' : 'Withdrawal',
        'Status': statuses[payment.status] || payment.status,
        'Payment method': paymentChannelName(payment.requested_payment_method || payment.requisite_type || '-', payment.traffic_type,
            getTransactionGrossCurrency(payment)),
        'Amount': numeric(getTransactionGrossAmount(payment)),
        'Exchange rate': numeric(payment.exchange_rate),
        'Amount USDT': numeric(payment.amount_usdt_before_fees),
        'Commission %': completed ? numeric(payment.merchant_commission_rate) : '-',
        'Commission USDT': completed ? numeric(payment.merchant_commission_usdt) : '-',
        'Created At': new Date(payment.created_at).toLocaleString('en-US'),
        'Completed At': payment.completed_at ? new Date(payment.completed_at).toLocaleString('en-US') : '-',
    };
};

export const createMerchantPaymentsWorkbook = (payments: MerchantExportPayment[]) => {
    const sheet = XLSX.utils.json_to_sheet(payments.map(merchantPaymentExportRow));
    return createMerchantPaymentsWorkbookFromSheet(sheet);
};

export const createMerchantPaymentsWorkbookFromSheet = (sheet: XLSX.WorkSheet) => {
    const formats: Record<string, string> = { G: '#,##0.00', H: '0.######', I: '0.######', J: '0.####', K: '0.######' };
    const range = XLSX.utils.decode_range(sheet['!ref'] || 'A1');
    for (let row = 1; row <= range.e.r; row++) {
        Object.entries(formats).forEach(([column, format]) => {
            const cell = sheet[`${column}${row + 1}`];
            if (cell?.t === 'n') cell.z = format;
        });
    }
    sheet['!cols'] = [25, 25, 22, 14, 20, 25, 18, 18, 18, 16, 20, 24, 24].map(wch => ({ wch }));
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, sheet, 'Payments');
    return workbook;
};
